import React from "react";
import { FormGenerationSummary } from "../../../types/form-generation-usage.types";

interface SummaryCardsProps {
  summary: FormGenerationSummary;
}

interface CardProps {
  label: string;
  value: string;
  testId: string;
  ariaLabel: string;
}

const Card: React.FC<CardProps> = ({ label, value, testId, ariaLabel }) => (
  <div
    className="bg-white rounded-lg border border-neutral-200 p-4 shadow-sm"
    data-testid={testId}
    aria-label={ariaLabel}
  >
    <div className="text-xs font-medium text-neutral-500 uppercase mb-1">
      {label}
    </div>
    <div
      className="text-2xl font-semibold text-neutral-900"
      data-testid={`${testId}-value`}
    >
      {value}
    </div>
  </div>
);

const formatNumber = (value: number): string => {
  return value.toLocaleString("pl-PL");
};

const formatDuration = (ms: number): string => {
  if (ms >= 1000) {
    return `${(ms / 1000).toFixed(1)}s`;
  }
  return `${ms}ms`;
};

export const FormGenerationSummaryCards: React.FC<SummaryCardsProps> = ({ summary }) => {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
      role="region"
      aria-label="Podsumowanie generacji de minimis"
    >
      <Card
        label="Liczba generacji"
        value={formatNumber(summary.totalGenerations)}
        testId="metric-total-generations"
        ariaLabel={`Liczba generacji: ${formatNumber(summary.totalGenerations)}`}
      />
      <Card
        label="Przetworzone wiersze"
        value={formatNumber(summary.totalRows)}
        testId="metric-total-rows"
        ariaLabel={`Przetworzone wiersze: ${formatNumber(summary.totalRows)}`}
      />
      <Card
        label="Poprawne generacje"
        value={formatNumber(summary.totalSuccessful)}
        testId="metric-total-successful"
        ariaLabel={`Poprawne generacje: ${formatNumber(summary.totalSuccessful)}`}
      />
      <Card
        label="Średni czas generacji"
        value={formatDuration(summary.averageDurationMs)}
        testId="metric-avg-duration"
        ariaLabel={`Średni czas generacji: ${formatDuration(summary.averageDurationMs)}`}
      />
    </div>
  );
};

export default FormGenerationSummaryCards;
